<template>
    <div>
        <v-dialog
            :value="value"
            max-width="1000px"
            scrollable
            @input="$emit('input', $event)"
            @keydown.enter.prevent="save"
            @keydown.esc.prevent="cancel"
        >
            <v-card :loading="loading" :disabled="disabled">
                <v-card-title class="text-h5 grey lighten-2">
                    <span class="text-h5">{{
                        record ? $t('edit_organizer_group') : $t('create_organizer_group')
                    }}</span>
                </v-card-title>
                <v-card-text style="max-height: var(--usable-dialog-height)">
                    <EditForm
                        ref="form"
                        :record="record"
                        @input="isValid = $event"
                        @loading="loading = $event"
                        @record-changed="$emit('record-changed', $event)"
                        @record-added="$emit('record-added', $event)"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <PlainBtn text @click.stop="cancel(false)">{{ $t('cancel') }}</PlainBtn>
                    <ActionBtn :loading="saving" :disabled="!isValid" @click="save">{{ $t('save') }}</ActionBtn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ConfirmDialog
            v-if="showCancelDlg"
            v-model="showCancelDlg"
            :title="$t('Cancel')"
            :message="$t('sure_cancel')"
            @confirm="cancel(true)"
        />
    </div>
</template>

<script>
import EditForm from '@/components/organizer_group/EditForm.vue';
import { OrganizerGroup } from '@/models/OrganizerGroup';
import { errToStr } from '@/helpers/tools';
import { mapActions } from 'vuex';

export default {
    name: 'OrganizerGroupEditDialog',
    components: {
        EditForm,
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        record: {
            type: OrganizerGroup,
            default: null,
        },
    },

    data() {
        return {
            showCancelDlg: false,
            saving: false,
            loading: false,
            isValid: false,
        };
    },

    computed: {
        disabled() {
            return this.loading || this.saving;
        },
    },

    methods: {
        ...mapActions(['runAsync']),

        async save() {
            this.saving = true;
            try {
                await this.runAsync(async () => await this.$refs.form.save());
                this.$emit('input', false);
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            } finally {
                this.saving = false;
            }
        },

        cancel(force = false) {
            if (!force && this.record?.hasUnsavedData()) {
                this.showCancelDlg = true;
            } else {
                this.$emit('input', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
